import {isLocalApi} from 'src/env'
import {restApiServiceRiddles} from './service'
import {localApiServiceRiddles} from './serviceLocal'

const APIServiceRiddles = isLocalApi ? localApiServiceRiddles : restApiServiceRiddles
APIServiceRiddles.init()

export default APIServiceRiddles
